import { App } from "vue";
import axios, { AxiosResponse } from "axios";

export default {
  install: (app: App): void => {
    app.config.globalProperties.$http = axios;
    const $http = app.config.globalProperties.$http;
    const valid_token = (response: AxiosResponse) => {
      if (response.data.status === 401) throw new Error(response.data.message);
      const token =
        sessionStorage.getItem("token") || response.data?.data?.token;
      $http.defaults.headers.common["Authorization"] = token;
      return response;
    };
    $http.interceptors.response.use(valid_token);
  },
};
